document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  /* ---------------- Search panel ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchClose = document.querySelector('[data-search-close]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.add('is-open');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 300);
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.classList.remove('is-open');
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
  }
  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  cartCloseEls.forEach(function (el) { el.addEventListener('click', closeCartDrawer); });

  /* ---------------- Hero slideshow ---------------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.hero-slide');
    var dots = slideshow.querySelectorAll('[data-slide-dot]');
    var prevBtn = slideshow.querySelector('[data-slide-prev]');
    var nextBtn = slideshow.querySelector('[data-slide-next]');
    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); resetTimer(); });
    });

    function resetTimer() {
      clearInterval(timer);
      if (slideshow.dataset.autoplay === 'true' && slides.length > 1) {
        timer = setInterval(next, parseInt(slideshow.dataset.interval, 10) || 6000);
      }
    }
    resetTimer();
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var slide = gallery.querySelector('[data-gallery-slide="' + index + '"]');
        if (slide) slide.classList.add('is-active');
      });
    });
  });

  /* ---------------- Variant option pills ---------------- */
  document.querySelectorAll('.product-page__option-values').forEach(function (group) {
    group.querySelectorAll('.option-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        // In production this should re-evaluate the matching variant
        // via the variant JSON and update the hidden select + price + gallery.
      });
    });
  });

  /* ---------------- Quantity steppers ---------------- */
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-decrease]');
    var plus = stepper.querySelector('[data-qty-increase]');
    if (minus) minus.addEventListener('click', function () {
      var val = Math.max((parseInt(input.value, 10) || 1) - 1, parseInt(input.min, 10) || 0);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var val = (parseInt(input.value, 10) || 1) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------------- Countdown timers ---------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minutesEl = el.querySelector('[data-cd-minutes]');
    var secondsEl = el.querySelector('[data-cd-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = new Date().getTime();
      var diff = end - now;
      if (diff <= 0) {
        [daysEl, hoursEl, minutesEl, secondsEl].forEach(function (e) { if (e) e.textContent = '00'; });
        return;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------- Quick view modal ---------------- */
  var quickViewModal = document.querySelector('[data-quick-view-modal]');
  var quickViewContent = document.querySelector('[data-quick-view-content]');
  var quickViewCloseEls = document.querySelectorAll('[data-quick-view-close]');

  document.querySelectorAll('[data-quick-view-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = btn.getAttribute('data-product-url');
      if (!url || !quickViewModal) return;
      quickViewModal.classList.add('is-open');
      if (quickViewContent) quickViewContent.innerHTML = '<p style="padding:60px;text-align:center;">Loading&hellip;</p>';
      fetch(url + '?view=quick-view')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          if (quickViewContent) quickViewContent.innerHTML = html;
        })
        .catch(function () {
          if (quickViewContent) quickViewContent.innerHTML = '<p style="padding:60px;text-align:center;">Unable to load product preview. <a href="' + url + '">View full page</a>.</p>';
        });
    });
  });
  quickViewCloseEls.forEach(function (el) {
    el.addEventListener('click', function () {
      if (quickViewModal) quickViewModal.classList.remove('is-open');
    });
  });

  /* ---------------- Escape key closes overlays ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (searchPanel) searchPanel.classList.remove('is-open');
      if (quickViewModal) quickViewModal.classList.remove('is-open');
      if (mobileNav) mobileNav.classList.remove('is-open');
    }
  });

});
